export const SCREENSHOT_VIEWS = [
  {
    id: 'quick-log',
    label: 'Quick Log',
    caption:
      'Feeds, diapers, sleep, and potty trips in one tap — breast, bottle, solids, or water. Works offline.',
  },
  {
    id: 'timeline',
    label: 'Timeline',
    caption:
      'Every feed, diaper, nap, potty trip, dose, and note in one reverse-chronological feed you can filter.',
  },
  {
    id: 'health',
    label: 'Health',
    caption:
      'Track an illness and what you gave for it. Medicine schedules show the last dose and when the next one is due, and can remind you.',
  },
  {
    id: 'milestones',
    label: 'Milestones',
    caption:
      'Nearly thirty firsts from birth to age five, each with a date, a note, and an optional photo or video.',
  },
  {
    id: 'trends',
    label: 'Trends',
    caption:
      'Growth, feeding, diapers, and potty training charted over time, with week, month, and all-time averages.',
  },
  {
    id: 'you',
    label: 'You',
    caption:
      'A private space for the parent: track your own mood and keep a daily note. Never synced, never shared.',
  },
] as const;

export type ScreenshotView = (typeof SCREENSHOT_VIEWS)[number];
export type ScreenshotViewId = ScreenshotView['id'];
export type ScreenshotMode = 'light' | 'dark';

export const DEFAULT_VIEW: ScreenshotViewId = 'quick-log';

/**
 * Screenshot assets live in `public/screenshots` and are named
 * `{view}-{light|dark}.png`, so a view id and a mode fully determine the src.
 */
export function screenshotSrc(view: ScreenshotViewId, mode: ScreenshotMode): string {
  return `/screenshots/${view}-${mode}.png`;
}

export function screenshotAlt(view: ScreenshotViewId, mode: ScreenshotMode): string {
  const label = SCREENSHOT_VIEWS.find((v) => v.id === view)?.label ?? view;
  return `Bramble ${label} screen, ${mode} appearance`;
}
